module.exports = __webpack_public_path__ + "static/img/bg_boss_header.37b13a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/boss-home/bg_boss_header.png
// module id = hGsH
// module chunks = 1